import { combineReducers } from 'redux';
import event from './event';
import app from './app';
import projects, { STATE_KEY as PROJECTS_STATE_KEY } from './projects';

export default combineReducers({
	event,	
	app,
	[PROJECTS_STATE_KEY]: projects
});